import React, { Component } from 'react'
import { Col } from 'reactstrap';
import { firebase } from '../../firebase';
import FileUploader from 'react-firebase-file-uploader';

export default class Uploader extends Component {
    state = {
        name: '',
        isUploading: false,
        progress:0
    }

    handleUploadStart = () => {
        this.setState({
            isUploading:true,
            progress:0
        });
    }

    handleUploadError = (error) => {
        this.setState({
            isUploading:false,
            progress:0
        });
        console.log(error);
    }

    handleUploadSuccess = (filename) => {
        this.setState({
            name: filename,
            isUploading:false,
            progress:100
        });
        this.props.filename(filename);
    }

    handleUploadPreogress = (progress) => {
        this.setState({
            progress
        });
    }

  render() {
    return (
        <Col>
            <FileUploader 
                accept="image/*"
                name="image"
                randomizeFilename
                storageRef={firebase.storage().ref('roboImages')}
                onUploadStart={this.handleUploadStart}
                onUploadError={this.handleUploadError}
                onUploadSuccess={this.handleUploadSuccess}
                onProgress={this.handleUploadPreogress}
            />
            {this.state.isUploading ? <p>Progress: {this.state.progress}</p> : null}
        </Col>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/widgets/uploader.js